// src/components/Toast.jsx
import { useEffect } from 'react';
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-react';
import styles from './Toast.module.css';

const TYPE_CONFIG = {
  success: { icon: CheckCircle, mod: styles.success },
  error:   { icon: XCircle,     mod: styles.error   },
  warning: { icon: AlertCircle, mod: styles.warning  },
  info:    { icon: Info,        mod: styles.info     },
};

export default function Toast({ message, type = 'info', onClose, duration = 5000 }) {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const { icon: Icon, mod } = TYPE_CONFIG[type] ?? TYPE_CONFIG.info;

  return (
    <div className={`${styles.toast} ${mod}`}>
      <div className={styles.inner}>
        <span className={styles.iconWrap}>
          <Icon size={20} aria-hidden="true" />
        </span>
        <div className={styles.body}>
          <p className={styles.message}>{message}</p>
        </div>
        <button onClick={onClose} className={styles.closeBtn} aria-label="Dismiss">
          <X size={16} />
        </button>
      </div>
    </div>
  );
}

export function ToastContainer({ toasts, removeToast }) {
  return (
    <div className={styles.container}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => removeToast(toast.id)}
          duration={toast.duration}
        />
      ))}
    </div>
  );
}
